module.exports = __webpack_public_path__ + "img/11846639_1479506852343383_3084841854848038747_n.9bda3656.jpg";